import {useMemo} from 'react';
import {MagnifyingGlassIcon} from '@heroicons/react/24/outline';
import {DateRangeInput} from '../../../../../components/general/DateRangeInput';
import {formatDateForInput, parseDate} from '../../../../../components/general/DateRangeInput/utils/dateRangeUtils.ts';
import {Input} from '../../../../../components/general/Input.tsx';
import {fieldLabelClasses} from '../../../../../components/general/fieldStyles.ts';
import {cn} from '../../../../../lib/utils.ts';

type ArchivedDocumentsFilterBarProps = {
    dateFrom: string;
    dateTo: string;
    fileName: string;
    onDateRangeChange: (dateFrom: string, dateTo: string) => void;
    onFileNameChange: (fileName: string) => void;
};

export function ArchivedDocumentsFilterBar({
    dateFrom,
    dateTo,
    fileName,
    onDateRangeChange,
    onFileNameChange,
}: ArchivedDocumentsFilterBarProps) {
    const dateRange = useMemo(() => ({from: parseDate(dateFrom), to: parseDate(dateTo)}), [dateFrom, dateTo]);

    return (
        <div className="mb-4 flex w-full flex-wrap items-end gap-4 bg-white">
            <div>
                <span className={cn(fieldLabelClasses, 'mb-2')}>Periode - uploaddatum</span>
                <div className="w-[234px]">
                    <DateRangeInput
                        value={dateRange}
                        onChange={(range) => onDateRangeChange(formatDateForInput(range.from), formatDateForInput(range.to))}
                    />
                </div>
            </div>
            <div>
                <label htmlFor="archived-documents-file-name" className={cn(fieldLabelClasses, 'mb-2')}>
                    Bestandsnaam
                </label>
                <div className="relative w-64">
                    <MagnifyingGlassIcon
                        className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-gray-400"
                        aria-hidden="true"
                    />
                    <Input
                        id="archived-documents-file-name"
                        type="search"
                        value={fileName}
                        onChange={(event) => onFileNameChange(event.target.value)}
                        placeholder="Zoek op bestandsnaam"
                        className="pl-9"
                    />
                </div>
            </div>
        </div>
    );
}
